<template>
  <validation-observer ref="validationobserver" v-slot="{ handleSubmit }">
    <b-form @submit.prevent="handleSubmit(salvar)">
      <h6 class="mb-3 text-left">
        <b-button class="float-right m-1" size="sm" type="submit">
          <font-awesome-icon icon="save" />
          Salvar
        </b-button>
      </h6>
      <b-row v-if="usuarioEdit" class="w-100">
        <b-col cols="6">
          <default-form-validation-provider label="Nome" v-slot="defaultState">
            <b-form-input id="input-nome" v-model="usuarioEdit.NOME" :state="defaultState.state" maxlength="80" />
          </default-form-validation-provider>
        </b-col>
        <b-col cols="6">
          <b-overlay :show="loadingCpf">
            <default-form-validation-provider label="CPF" v-slot="defaultState">
              <b-form-input v-model="cpfFormatado" @update="verificaCpf" :disabled="loadingCpf"
                :state="defaultState.state && cpfState" v-bind="cpfMaskedInputProps" />
              <b-form-invalid-feedback v-if="cpfState === false">CPF inválido.</b-form-invalid-feedback>
              <b-form-valid-feedback v-if="cpfState === true">CPF válido.</b-form-valid-feedback>
            </default-form-validation-provider>
          </b-overlay>
        </b-col>
        <b-col cols="6">
          <default-form-validation-provider label="RG" v-slot="defaultState" rules="">
            <b-form-input v-model="usuarioEdit.RG" type="number" :state="defaultState.state" />
          </default-form-validation-provider>
        </b-col>
        <b-col cols="6">
          <default-form-validation-provider label="Email" v-slot="defaultState">
            <b-form-input v-model="usuarioEdit.EMAIL" type="email" :state="defaultState.state" />
          </default-form-validation-provider>
        </b-col>
        <b-col cols="6">
        <default-form-validation-provider label="Telefone" v-slot="defaultState" rules="required|telefoneComDDD">
          <b-form-input
            :value="telefoneFormatted"
            @input="onTelefoneInput"
            @keydown="onTelefoneKeydown"
            :state="defaultState.state"
            v-bind="telefoneMaskedInputProps"
            class="form-control"
          />
        </default-form-validation-provider>
        </b-col>
        <b-col cols="6">
          <default-form-validation-provider label="Sexo" v-slot="defaultState">
            <b-form-select id="select-sexo" v-model="usuarioEdit.ID_CRP_SEXO" :options="listaSexo"
              :state="defaultState.state" />
          </default-form-validation-provider>
        </b-col>
        <b-col cols="6">
          <default-form-validation-provider label="Protocolo eTCE" v-slot="defaultState" rules="">
            <b-form-input v-model="usuarioEdit.NR_PROTOCOLO" :state="defaultState.state" />
          </default-form-validation-provider>
        </b-col>
        <b-col cols="6">
          <default-form-validation-provider label="Código OAB" v-slot="defaultState" rules="">
            <b-form-input v-model="usuarioEdit.OAB" :state="defaultState.state" maxlength="8" />
          </default-form-validation-provider>
        </b-col>
        <b-col cols="6">
          <default-form-validation-provider label="Data de Início da Vigência" v-slot="defaultState">
            <b-form-datepicker id="input-data-ini-vigencia" :state="defaultState.state"
              v-model="usuarioEdit.DATA_INICIO" v-bind="datePickerProps">
            </b-form-datepicker>
          </default-form-validation-provider>
        </b-col>
        <b-col cols="6">
          <span>Autoriza comunicação por email, SMS, ZAP ou afins:
            {{ simOuNao(usuarioEdit.FL_COMUNICA_TELEFONE) }}</span>
        </b-col>
        <b-col cols="6">
          <default-form-validation-provider label="UF" v-slot="defaultState">
            <b-form-select id="select-uf" v-model="ufEscolhido" :options="listaUFs" @change="obterMunicipios()"
              :state="defaultState.state" />
          </default-form-validation-provider>
        </b-col>
        <b-col cols="6">
          <b-overlay :show="loadingMunicipios">
            <default-form-validation-provider label="Município" v-slot="defaultState">
              <b-form-select id="select-municipio" v-model="usuarioEdit.ID_CRP_MUNICIPIO" :options="listaMunicipios"
                :state="defaultState.state" :disabled="!ufEscolhido">
              </b-form-select>
            </default-form-validation-provider>
          </b-overlay>
        </b-col>
        <b-col cols="6">
          <default-form-validation-provider label="Logradouro" v-slot="defaultState">
            <b-form-input id="input-logradouro" v-model="usuarioEdit.NM_LOGRADOURO" :state="defaultState.state" />
          </default-form-validation-provider>
        </b-col>
        <b-col cols="6">
          <default-form-validation-provider label="Número" v-slot="defaultState">
            <b-form-input id="input-nro" v-model="usuarioEdit.NU_NUMERO" type="number" :state="defaultState.state" />
          </default-form-validation-provider>
        </b-col>
        <b-col cols="6">
        <default-form-validation-provider label="CEP" v-slot="defaultState">
          <b-form-input
            id="input-cep"
            :value="cepFormatted"
            @input="onCepInput"
            @keydown="onCepKeydown"
            :state="defaultState.state"
            v-bind="cepMaskedInputProps"
          />
        </default-form-validation-provider>
        </b-col>
        <b-col cols="6">
          <default-form-validation-provider label="Complemento" v-slot="defaultState" rules="">
            <b-form-input id="input-complemento" v-model="usuarioEdit.NM_COMPLEMENTO" :state="defaultState.state" />
          </default-form-validation-provider>
        </b-col>
        <b-col cols="6">
          <default-form-validation-provider label="Bairro" v-slot="defaultState">
            <b-form-input id="input-bairro" v-model="usuarioEdit.NM_BAIRRO" :state="defaultState.state" />
          </default-form-validation-provider>
        </b-col>
      </b-row>
    </b-form>

    <validation-observer ref="validationobserver">
      <b-modal id="modal-usuario" title="CPF já vinculado!" header-bg-variant="secondary" header-text-variant="light"
        @hide="closeModal" centered>
        <b-container>
          <b-row>
            <b-col cols="12" lg="12">O CPF: <b>{{ cpfFormatado }}</b> já está vinculado a um usuário.</b-col>
            <b-col cols="12" lg="12">Deseja mudar o CPF atual ou editar o usuário que o possui?</b-col>
          </b-row>
        </b-container>
        <template #modal-footer>
          <b-button size="sm" variant="danger" @click="closeModal">Ficar aqui</b-button>
          <b-button size="sm" variant="success" @click="enviarNovoId">Editar usuário já existente</b-button>
        </template>
      </b-modal>
    </validation-observer>

  </validation-observer>
</template>

<script lang="ts">
import { Component, Ref, Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { store } from "@/store";
import { UtilsTS } from "@/utilsts";
import { ValidationObserver } from "vee-validate";
import { DatePickerDefaultProps } from "@/types/form-default-props";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";
import { SelectValue } from "@/types/select-value";
import { PropType } from "vue";
import { Usuario } from "@/types/administracao/usuarios/usuario";
import municipioService from "@/services/administracao/municipioService";
import usuarioService from "@/services/administracao/usuarioService";

const CompProps = Vue.extend({
  name: "AbaEditarDadosPessoaisUsuario",
  components: { DefaultFormValidationProvider, ValidationObserver },
  props: {
    usuario: {
      type: Object as PropType<Usuario>,
      required: true,
    },
  },
});

@Component
export default class AbaEditarDadosPessoaisUsuario extends mixins(
  UtilsTS,
  CompProps
) {
  @Ref("validationobserver") validationobserver: InstanceType<
    typeof ValidationObserver
  >;
  listaSexo: SelectValue[] = [
    { text: "Feminino", value: 2 },
    { text: "Masculino", value: 1 },
  ];
  usuarioEdit: Usuario | null = null;
  cpfFormatado = "";
  loadingCpf = false
  idUsuarioNovo: number | null = null
  idUsuarioTemp: number | null = null
  cpfState: null | boolean = null
  ufEscolhido = 0;
  listaUFs: SelectValue[] = [];
  loadingUFs = false;
  listaMunicipios: SelectValue[] = [];
  loadingMunicipios = false;
  datePickerProps = DatePickerDefaultProps;
  telefoneDigits = "";
  cepDigits = "";

  async verificaCpf(_cpf: string): Promise<any> {
    try {
      this.idUsuarioNovo = null
      this.idUsuarioTemp = null
      this.cpfState = false
      if (this.cpfFormatado && (this.cpfFormatado.length === 14 || this.cpfFormatado.length === 11)) {
        this.loadingCpf = true
        const cpf = this.trataCpfParaEnvio(_cpf)
        const valid = this.validarCPF(cpf)
        if (valid) {
          this.cpfState = true;
          const respIdNewUser = await usuarioService.verificaCpf(cpf)
          const respIdTempUser = respIdNewUser === null ? await usuarioService.verificaCpfNovoUsuario(cpf) : null
          if (respIdNewUser !== null && respIdNewUser !== this.usuarioEdit?.ID_USUARIO) {
            this.idUsuarioNovo = respIdNewUser;
            this.openModal();
          } else if (respIdTempUser !== null) {
            if (this.usuarioEdit?.ID_USUARIO) {
              this.cpfState = false
              this.cpfFormatado = ''
              this.$toast.error('CPF vinculado a outro usuário!')
            } else {
              this.idUsuarioTemp = respIdTempUser;
              this.openModal();
            }
          }
        } else this.cpfState = false
      }
    } catch (error: any) {
      this.tratarError(error)
    } finally {
      this.cpfFormatado = this.formatCpfMask(_cpf);
      this.loadingCpf = false
    }
  }

  trataCpfParaEnvio(cpf: string): string {
    return cpf.length >= 11 ? cpf.replaceAll('-', '').replaceAll('.', '') : cpf
  }

  formatCpf(cpf: string): string {
    return cpf.replace(/\D/g, "") // Remove all non-digit characters
      .replace(/(\d{3})(\d)/, "$1.$2") // Add dot after first 3 digits
      .replace(/(\d{3})(\d)/, "$1.$2") // Add dot after next 3 digits
      .replace(/(\d{3})(\d{1,2})$/, "$1-$2") ?? "";
  }

  get telefoneFormatted(): string {
    return this.formatTelefoneMask(this.telefoneDigits);
  }

  get cepFormatted(): string {
    return this.formatCepMask(this.cepDigits);
  }

  onTelefoneInput(value: string): void {
    this.telefoneDigits = this.digitsOnly(value, 11);
  }

  onCepInput(value: string): void {
    this.cepDigits = this.digitsOnly(value, 8);
  }

  onTelefoneKeydown(e: KeyboardEvent): void {
    const allowed = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Home", "End", "Tab"];
    if (e.ctrlKey || e.metaKey) return;
    if (allowed.includes(e.key)) return;
    if (!/^\d$/.test(e.key)) e.preventDefault();
  }

  onCepKeydown(e: KeyboardEvent): void {
    const allowed = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Home", "End", "Tab"];
    if (e.ctrlKey || e.metaKey) return;
    if (allowed.includes(e.key)) return;
    if (!/^\d$/.test(e.key)) e.preventDefault();
  }

  openModal() {
    try {
      this.$bvModal.show('modal-usuario')
    } catch (error) {
      this.$toast.error('CPF vinculado a outro usuário!')
    }
  }
  closeModal() {
    if (this.idUsuarioTemp === null) this.cpfFormatado = ''
    this.$bvModal.hide('modal-usuario')
  }

  async enviarNovoId() {
    if (this.idUsuarioTemp) {
      const novoUsuario = await usuarioService.getNovoUsuarioById(String(this.idUsuarioTemp));
      this.usuarioEdit = new Usuario(novoUsuario);
      return this.closeModal()
    } else {
      const novoId = String(this.idUsuarioNovo)
      this.$emit('idAtualizado', novoId)
    }
  }

  async salvar() {
    store.blockScreen = true;
    try {
      const isValid = await this.validationobserver.validate();
      if (!isValid || this.cpfState === false) {
        this.$toast.error('Cadastro inválido!\nVerifique os campos.')
        return console.error(this.validationobserver)
      };
      if (this.usuarioEdit) {
        this.usuarioEdit.NM_TELEFONE = this.telefoneDigits;
        this.usuarioEdit.NM_CEP = this.cepDigits;
      }
      if (this.usuarioEdit?.ID_USUARIO) {
        if (this.usuarioEdit?.CPF) this.usuarioEdit.CPF = this.trataCpfParaEnvio(this.cpfFormatado);
        await usuarioService.atualizarDadosUsr(
          this.usuarioEdit,
          this.usuarioEdit?.ID_USUARIO
        );
        this.$emit("dadosAtualizados");
        return this.$toast.success(`Os dados de usuário editados foram salvos!`);
      }
      if (this.cpfFormatado && this.usuarioEdit) this.usuarioEdit.CPF = this.trataCpfParaEnvio(this.cpfFormatado);
      const usuarioTemp = this.idUsuarioTemp ? true : false
      const novoUsuario: Usuario = await usuarioService.criarNovoUsuario(this.usuarioEdit, usuarioTemp);
      if (novoUsuario?.ID_USUARIO) {
        this.$toast.success(`O usuário ${novoUsuario?.NOME} foi criado com sucesso!`);
        return this.$router.push({ path: `/seguranca-administracao/usuarios/${novoUsuario?.ID_USUARIO}/editar`, });
      }
      this.$toast.error(`Não foi possível achar o usuário criado!`);
      return this.$router.push({ path: `/seguranca-administracao/usuarios` });
    } catch (e: any) {
      this.tratarError(e, true);
    } finally {
      store.blockScreen = false;
    }
  }

  async obterMunicipios() {
    try {
      if (this.ufEscolhido === 0) {
        this.listaMunicipios = [];
        return;
      }
      this.loadingMunicipios = true;
      const muns = await municipioService.getMunicipios(this.ufEscolhido);
      this.listaMunicipios = muns.map((u) => ({
        value: u.ID_MUNICIPIO,
        text: u.NM_NOME,
      }));
    } catch (e: any) {
      this.listaMunicipios = [];
      this.tratarError(e);
    } finally {
      this.loadingMunicipios = false;
    }
  }

  async obterUFs() {
    try {
      this.loadingUFs = true;
      const ufs = await municipioService.getUFs();
      this.listaUFs = ufs.map((u) => ({
        value: u.ID_UF,
        text: u.NM_SIGLA + " - " + u.NM_NOME,
      }));
    } catch (e: any) {
      this.listaUFs = [];
      this.tratarError(e);
    } finally {
      this.loadingUFs = false;
    }
  }

  sincronizarMunicipio() {
    this.ufEscolhido = this.usuarioEdit?.CRP_MUNICIPIO?.ID_UF ?? 29;
    this.obterMunicipios();
  }

  alterarTelPlaceholder() {
    const input: any = document.querySelector(".vti__input");
    if (input) input.placeholder = "Digite o número de telefone aqui.";
  }

  async mounted() {
    try {
      this.usuarioEdit = Object.assign(new Usuario(), this.usuario);
      this.telefoneDigits = this.digitsOnly(this.usuarioEdit?.NM_TELEFONE || "", 11);
      this.cepDigits = this.digitsOnly(this.usuarioEdit?.NM_CEP || "", 8);
      if (!this.usuarioEdit.ID_USUARIO) this.usuarioEdit.DATA_INICIO = new Date(new Date().getFullYear(), 0, 1);
      this.cpfFormatado = this.formatCpfMask(this.usuarioEdit.CPF || "");
      await this.obterUFs();
      this.sincronizarMunicipio();
      this.$nextTick(() => {
        this.alterarTelPlaceholder();
      });
    } catch (e: any) {
      console.error("Problema ao montar o componente AbaEditarDadosPessoaisUsuario", e);
    } finally {
      store.blockScreen = false;
    }
  }
}
</script>

<style scoped>
::v-deep div.vti__dropdown {
  display: none;
}
</style>
